import http from "./apiServices"

export const postUsableDiscounts = (discountInfo) => {
  return http.post("usableDiscounts", discountInfo)
}

export const postUsableDiscountByCode = ({ discountCode, discountInfo }) => {
  return http.post(`usableDiscounts/${encodeURIComponent(discountCode)}`, discountInfo)
}
